import { useTranslation } from "contexts/Safra/TranslationContext";
import { AlignRadio, Radio } from "./styles";

export function RadioComponent({option, index, handleClick}){
    const { t } = useTranslation();
    return(
         <AlignRadio key={option.value} id={`align_${option.value}`}>
            <Radio
                type="radio"
                name="order"
                id={`radio${index}`}
                value={option.value}
                onClick={handleClick}
                defaultChecked={index === 0}
            />
            <label htmlFor={`radio${index}`}>{option.labelKey ? t(option.labelKey) : option.label} </label>
        </AlignRadio>
    )
}